<template>
  <div style="margin-top:30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="机构名称"
        prop="groupName"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.groupName"
          placeholder="请输入机构名称"
          @change="value=>form.groupName = value.replace(/[\s]/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="机构地址"
        prop="address"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.address"
          placeholder="请输入地址"
          @change="value=>form.address = value.replace(/[\s]/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="400客服"
        prop="telephone"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.telephone"
          placeholder="400-"
          @change="value=>form.telephone = /^[-\d]+$/.test(value)?value:''"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'PartnerShipsEdit',
  data() {
    return {
      emptyForm: {},
      form: {
        groupName: '',
        wwwUrl: '',
        address:'',
        telephone: ''
      },
      rules: {
        groupName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { max:32, message: "最大长度不超过 256 个字符" }
        ],
        address: [
          { max:500, message: "最大长度不超过 500 个字符" }
        ],
        telephone: [
          { max:16, message: "最大长度不超过 16 个字符" }
        ]
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.$refs["form"].resetFields()
      request({ url: `/ntocc-basic-api/partyGroup/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.form
          const rLoading = this.openLoading();
          request({ url: '/ntocc-basic-api/partyGroup', method: 'put', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherEditMethod')
            this.$store.dispatch('components/getBranchList')
          }).then(()=>this.$refs['form'].resetFields())
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'edit')
    },
    handleImgSuccess(res, file) {
      this.$message({ message: res.msg, type: 'success' })
      this.form.img = res.data
    },
    // 上传验证
    beforeImgUpload(file) {
      const isJPG =
                    file.type === 'image/jpeg' ||
                    file.type === 'image/bmp' ||
                    file.type === 'image/png'
      const isLtnM = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG,BMP,PNG 格式!')
      }
      if (!isLtnM) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isJPG && isLtnM
    }

  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
